import React, { useState } from "react";
import { useUser } from "../../contexts/UserContext";
import adminApi from "../../services/adminApi";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [copied, setCopied] = useState(false);
  const { user } = useUser();

  const generatePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";
    for (let i = 0; i < 8; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const newPassword = generatePassword();
      await adminApi.resetPassword(email, newPassword, user.id);
      setMessage(`Adgangskode er blevet nulstillet.`);
      setNewPasswordValue(newPassword);
      setCopied(false);
      setEmail("");
    } catch (error) {
      setMessage(error.message || "Der opstod en fejl ved nulstilling af adgangskode");
      setNewPasswordValue("");
      setCopied(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="settings">
      <h2>Nulstil adgangskode</h2>
      <form onSubmit={handleSubmit}>
        {message && (
          <div className="message" role="alert">
            {message}
            {newPasswordValue && (
              <div className="password-display">
                <div className="password-container">
                  <span className="password-value">{newPasswordValue}</span>
                  <button
                    type="button"
                    className={`copy-button ${copied ? 'copied' : ''}`}
                    aria-label="Kopier adgangskode"
                    onClick={() => {
                      navigator.clipboard.writeText(newPasswordValue);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 1200);
                    }}
                  >
                    <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`}></i>
                    {copied ? 'Kopieret!' : 'Kopier'}
                  </button>
                </div>
                <p className="password-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  Gem denne adgangskode - den vises kun én gang!
                </p>
              </div>
            )}
          </div>
        )}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <div className="input-with-icon">
            <i className="fas fa-envelope"></i>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Indtast brugerens email"
              required
              disabled={isLoading}
            />
          </div>
        </div>
        <button type="submit" className="button button-primary" disabled={isLoading}>
          {isLoading ? (
            <span className="loading">
              <i className="fas fa-spinner fa-spin"></i> Nulstiller...
            </span>
          ) : (
            "Nulstil adgangskode"
          )}
        </button>
      </form>

      <style jsx>{`
        .password-display {
          margin-top: 1rem;
          padding: 1rem;
          background: #f8fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .password-container {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 0.5rem;
        }

        .password-value {
          font-family: 'Roboto Mono', monospace;
          font-size: 1.1rem;
          font-weight: 600;
          padding: 0.5rem 1rem;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          letter-spacing: 0.05em;
          color: #2d3748;
        }

        .copy-button {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: 6px;
          font-size: 0.9rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          background: #edf2f7;
          color: #4a5568;
        }

        .copy-button:hover {
          background: #e2e8f0;
        }

        .copy-button.copied {
          background: #c6f6d5;
          color: #2f855a;
        }

        .password-warning {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin: 0;
          font-size: 0.9rem;
          color: #e53e3e;
        }

        .password-warning i {
          font-size: 1rem;
        }
      `}</style>
    </div>
  );
}

export default ResetPassword; 